import type * as React from 'react';
import { UserProvider } from 'stores/CurrentUser';
import { useIsLoggedIn } from 'stores/LoggedInStatus';
import { Logo } from './Logo';
import { Navigation } from './Navigation';
import { container, mainNav } from './index.css';

export { headerHeight } from './index.css';

export const Header: React.FC = () => {
  const isLoggedIn = useIsLoggedIn();

  return (
    <header className={mainNav}>
      <div className={container}>
        <Logo />
        {isLoggedIn && (
          <UserProvider>
            <Navigation />
          </UserProvider>
        )}
      </div>
    </header>
  );
};
